import { useTranslation, Trans } from 'react-i18next'

interface Props {
  legalRef: string
  restricted?: boolean
  onDismiss: () => void
}

export default function DocumentUnavailableModal({ legalRef, restricted, onDismiss }: Props) {
  const { t } = useTranslation()

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full mx-4 p-6">
        <p className="text-sm text-gray-600 mb-6">
          <Trans
            i18nKey={restricted ? 'documentUnavailable.restricted' : 'documentUnavailable.message'}
            values={{ legalRef }}
            components={{ strong: <strong className="font-semibold text-gray-800" /> }}
          />
        </p>
        <button
          onClick={onDismiss}
          className="w-full px-4 py-2 text-sm font-medium bg-brand text-white rounded-lg hover:bg-brand/90 transition-colors"
        >
          {t('documentUnavailable.dismiss')}
        </button>
      </div>
    </div>
  )
}
